'use strict';

var appDom = require('./app-dom');

var state;

var isPlaying = function() {

	return state && state.isPlaying;

};

var togglePlayPauseControl = function() {

	appDom.slideshow
		.find('.slideshow__control--play')
			.toggleClass('proofing-icon--play proofing-icon--pause');

};

var startAutoPlay = function() {

	state = { isPlaying: true };

	// Force auto play to always go left to right.
	appDom.slideshowSlider.slick('getSlick').direction = 1;

	appDom.slideshowSlider.slick('slickPlay');

	togglePlayPauseControl();

};

var stopAutoPlay = function() {

	if (isPlaying()) {

		state = null;

		appDom.slideshowSlider.slick('slickPause');

		togglePlayPauseControl();

	}

};

var toggleAutoPlay = function() {

	if (isPlaying()) {

		stopAutoPlay();

	} else {

		startAutoPlay();

	}

};

var previous = function() {

	stopAutoPlay();

	appDom.slideshowSlider.slick('slickPrev');

};

var next = function() {

	stopAutoPlay();

	appDom.slideshowSlider.slick('slickNext');

};

var showControl = function($el) {

	$el.toggleClass('slideshow__control-hover-zone--is-hovered');

};

module.exports = {

	startAutoPlay: startAutoPlay,
	stopAutoPlay: stopAutoPlay,
	toggleAutoPlay: toggleAutoPlay,
	previous: previous,
	next: next,
	showControl: showControl

};
